export default __webpack_public_path__ + "974167ecf4bc3b2195b8b8ca3eba3aa6.svg";